"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var getCurrencySymbol = function (code) {
    return constants_1.CURRENCY_CODES[code] || constants_1.CURRENCY_CODES.RUB;
};
exports.default = getCurrencySymbol;
